module.exports = __webpack_public_path__ + "img/costa-rica-logo-icon.72f9d03d.png";